/*
 * @Author: shannyHuang
 * @Date: 2022-03-28 15:21:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-29 14:18:24
 * @FilePath: /wemeet-web-activity/src/components/ErrorTips/index.tsx
 */
import React from 'react';
import { Alert, Button } from '@tencent/tea-component';
import ReactDOM from 'react-dom';

interface Props {
  visible?: boolean;
  role?: number; // 当前身份
  onCancel?: () => Promise<void>;
  onDelete?: () => Promise<void>;
}
export default function MeetingErrorTips(props: Props) {
  const { role, visible, onCancel, onDelete } = props;
  return (
    <Alert
      type="warning"
      visible={visible}
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onClose={() => onCancel?.()}
      extra={
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        role !== 1 && (
          <Button
            type="link"
            onClick={() => {
              onCancel?.();
            }}
          >
            知道了
          </Button>
        )
      }
    >
      {role === 1 && (
        <>
          <span
            style={{
              color: '#000',
            }}
          >
            因关联会议已删除，活动失效，请及时下架活动。
          </span>
          <Button type="link" style={{ color: '#006FFF' }} onClick={onDelete}>
            下架
          </Button>
        </>
      )}
      {role !== 1 && (
        <p
          style={{
            color: '#000',
          }}
        >
          活动异常，无法打开，如有疑问请联系主办方。
        </p>
      )}
    </Alert>
  );
}

MeetingErrorTips.close = () => {
  MeetingErrorTips.show({ visible: false });
};

MeetingErrorTips.show = (props: Props) => {
  const { visible = true, role = 1 } = props;
  let el = document.getElementById('el-err-tips');
  if (!el) {
    el = document.createElement('div');
    el.id = 'el-sale-modal';
    document.body.appendChild(el);
  }
  const onOk = () => {
    Promise.resolve(props?.onDelete && props?.onDelete()).then(() => MeetingErrorTips.close());
  };
  const onCancel = () => {
    Promise.resolve(props?.onCancel && props?.onCancel()).then(() => MeetingErrorTips.close());
  };
  ReactDOM.render(
    <MeetingErrorTips visible={visible} role={role} onDelete={onOk} onCancel={onCancel} />,
    el,
  );
};
